import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ListItemText, IconButton, TextField, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SideDrawer from "../SideDrawer/index";
import { Box, Modal, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import {
  GET_COURSES,
  DELETE_COURSE,
  GET_MODULES,
  GET_VIDEO,
  GET_PDF,
  GO_LIVE,
  CANCEL_LIVE,
  GET_PROJECTS,
  DELETE_PROJECT,
  POST_PRIORITY,
  GET_COURSE,
  ADD_SECTION,
  GET_LANDING_SECTIONS_API,
  UPDATE_LANDING_SECTION_API,
  DELETE_LANDING_SECTION_API,
} from "../../../api/courseupload";
import axios from "axios";
import MessagePopup from "../../MessagePopup";
import StreamIcon from "@mui/icons-material/Stream";
import CancelIcon from "@mui/icons-material/Cancel";
import PreviewIcon from "@mui/icons-material/Preview";
import ProjectUpload from "../ProjectUpload.jsx/index";
import ModalCustom from "../../Modal";
import {
  MenuItem,
  Select,
  InputBase,
  TextareaAutosize,
  Box as MuiBox,
  Typography as MuiTypography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { GET_PRESIGNED_URL } from "../../../api/presignedurl";

export default function CourseList() {
  const [selectedModule, setSelectedModule] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [deleteCourseIndex, setDeleteCourseIndex] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [course, setCourse] = useState([]);
  const [modules, setModules] = React.useState([]);
  const [videos, setVideos] = React.useState([]);
  const [pdfs, setPdfs] = React.useState([]);
  const [moduleName, setModuleName] = React.useState("");
  const [resp, setResp] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [added, setAdded] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [priority, setPriority] = useState(10000);
  const [open, setOpen] = useState(false);
  const [addSectionOpen, setAddSectionOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState("");
  const [sectionData, setSectionData] = useState({});
  const [currentCourseId, setCurrentCourseId] = useState(null);
  const [loadingSection, setLoadingSection] = useState(false);
  const [errorSection, setErrorSection] = useState("");
  const [expandedSections, setExpandedSections] = useState({});
  const [fetchedSections, setFetchedSections] = useState({});
  const [loadingSections, setLoadingSections] = useState({});

  // State for Update and Delete functionality
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [currentEditingSection, setCurrentEditingSection] = useState(null);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState(null); // Will hold { courseId, type }

  useEffect(() => {
    axios
      .get(GET_COURSES)
      .then((data) => {
        const sortedCourses = data.data.data.sort(
          (a, b) => (a.priority || 1000) - (b.priority || 1000)
        );
        setCourse(sortedCourses);
        setUpdated(false);
        setAdded(false);
      })
      .catch((err) => console.log("Error fetching courses", err));
  }, [updated, added, openDelete, openPopUp]);

  const fetchModules = () => {
    axios
      .get(GET_MODULES + `/${courseId}`)
      .then((res) => setModules(res.data.message))
      .catch(console.error);
  };
  const fetchProjects = () => {
    axios
      .get(GET_PROJECTS + `${courseId}`)
      .then((res) => setProjects(res.data.message))
      .catch(console.error);
  };
  const checkUpdated = (value) => setUpdated(value);
  const checkAdded = (value) => setAdded(value);

  const deleteSubmit = () => {
    setOpenDelete(false);
    axios
      .delete(DELETE_COURSE + deleteCourseIndex)
      .then(() => {
        setResp("Course Deleted Successfully");
        setOpenPopUp(true);
      })
      .catch(console.error);
  };
  const handleDeleteProject = () => {
    axios
      .delete(DELETE_PROJECT + selectedProject)
      .then(() => {
        setSelectedProject(null);
        setAdded(true);
        handleCloseDialog();
        fetchProjects();
      })
      .catch(console.error);
  };

  const u = makeStyles({
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      border: "none",
      borderRadius: "3px",
      textAlign: "center",
      color: "black",
      width: 600,
      p: 4,
      padding: "1rem 3rem",
      "@media only screen and (max-width: 726px)": { width: "90%", p: 3 },
    },
  });
  const classes = u();

  const handleModuleClick = (moduleId) => {
    setSelectedModule(moduleId);
    axios
      .get(GET_VIDEO + moduleId)
      .then((res) => setVideos(res.data.data))
      .catch(console.error);
    axios
      .get(GET_PDF + moduleId)
      .then((res) => setPdfs(res.data.data))
      .catch(console.error);
  };

  const handleCloseDialog = () => {
    setSelectedModule(null);
    setModuleName("");
    setSelectedProject(null);
    setProjectName("");
    setProjectDescription("");
    setOpen(false);
    setUpdated(true);
  };
  const deleteBox = (
    <Box className={classes.style}>
      <Typography variant="h5" mb={1}>
        Are you sure want to delete?
      </Typography>
      <Box>
        <Button
          onClick={deleteSubmit}
          variant="contained"
          color="secondary"
          sx={{ m: 1 }}
        >
          Yes
        </Button>
        <Button
          onClick={() => setOpenDelete(false)}
          variant="outlined"
          sx={{ m: 1 }}
        >
          No
        </Button>
      </Box>
    </Box>
  );
  const handleGoLive = (id) => {
    axios
      .patch(GO_LIVE + id)
      .then(() => {
        setResp("Course Is Live");
        setOpenPopUp(true);
      })
      .catch(console.error);
  };
  const handleCancelGoLive = (id) => {
    axios
      .patch(CANCEL_LIVE + id)
      .then(() => {
        setResp("Course Is No Longer Live");
        setOpenPopUp(true);
      })
      .catch(console.error);
  };
  const handleSetPriority = () => {
    axios
      .post(POST_PRIORITY + courseId, { priority })
      .then(() => {
        setResp("Priority Set");
        setOpenPopUp(true);
        handleCloseDialog();
      })
      .catch(console.error);
  };

  async function uploadImageAndGetUrl(file, courseName, identifier) {
    const ext = file.name.split(".").pop();
    const safeCourse = courseName.replace(/[^a-zA-Z0-9_-]/g, "_");
    const safeIdentifier = (identifier || "section").replace(
      /[^a-zA-Z0-9_-]/g,
      "_"
    );
    const path = `course/landing/${safeCourse}/${safeIdentifier}.${ext}`;
    const contentType = file.type;
    const { data } = await axios.post(GET_PRESIGNED_URL, { path, contentType });
    await axios.put(data.uploadUrl, file, {
      headers: { "Content-Type": contentType },
    });
    return data.publicUrl;
  }

  const handleExpandSections = async (courseId) => {
    setExpandedSections((prev) => ({ ...prev, [courseId]: !prev[courseId] }));
    if (!expandedSections[courseId] && !fetchedSections[courseId]) {
      await refreshSections(courseId);
    }
  };

  const refreshSections = async (courseId) => {
    setLoadingSections((prev) => ({ ...prev, [courseId]: true }));
    try {
      const res = await axios.get(`${GET_LANDING_SECTIONS_API}/${courseId}`);
      setFetchedSections((prev) => ({
        ...prev,
        [courseId]: res.data.sections || [],
      }));
    } catch (err) {
      console.error("Failed to fetch sections:", err);
      setFetchedSections((prev) => ({ ...prev, [courseId]: [] }));
    } finally {
      setLoadingSections((prev) => ({ ...prev, [courseId]: false }));
    }
  };

  const handleSectionSubmit = async () => {
    if (!currentCourseId) return;
    setLoadingSection(true);
    setErrorSection("");
    let finalData = { ...sectionData };
    try {
      // Image upload logic for add
      if (selectedSection === "programmeOutcomes" && finalData.outcomes) {
        finalData.outcomes = await Promise.all(
          finalData.outcomes.map(async (o) =>
            o.image && o.image instanceof File
              ? {
                  ...o,
                  image: await uploadImageAndGetUrl(
                    o.image,
                    course.find((c) => c._id === currentCourseId)?.courseName ||
                      "c",
                    o.text || "outcome"
                  ),
                }
              : o
          )
        );
      }
      if (selectedSection === "workExCertificates" && finalData.certs) {
        finalData.certs = await Promise.all(
          finalData.certs.map(async (c) =>
            c.image && c.image instanceof File
              ? {
                  ...c,
                  image: await uploadImageAndGetUrl(
                    c.image,
                    course.find((co) => co._id === currentCourseId)
                      ?.courseName || "c",
                    c.buttonName || "cert"
                  ),
                }
              : c
          )
        );
      }

      await axios.post(ADD_SECTION, {
        courseId: currentCourseId,
        type: selectedSection,
        data: finalData,
      });
      setAddSectionOpen(false);
      setSelectedSection("");
      setSectionData({});
      await refreshSections(currentCourseId);
    } catch (err) {
      setErrorSection(err.response?.data?.message || "Error adding section");
    } finally {
      setLoadingSection(false);
    }
  };

  const handleEditClick = (section, parentCourseId) => {
    setCurrentEditingSection(section);
    setCurrentCourseId(parentCourseId); // Set parent course ID for the update API call
    setSectionData(JSON.parse(JSON.stringify(section.data)));
    setIsUpdateModalOpen(true);
    setErrorSection("");
  };

  const handleUpdateSectionSubmit = async () => {
    if (!currentEditingSection || !currentCourseId) return;
    setLoadingSection(true);
    setErrorSection("");
    try {
      // Image upload logic for update
      if (
        currentEditingSection.type === "programmeOutcomes" &&
        sectionData.outcomes
      ) {
        sectionData.outcomes = await Promise.all(
          sectionData.outcomes.map(async (o) =>
            o.image && o.image instanceof File
              ? {
                  ...o,
                  image: await uploadImageAndGetUrl(
                    o.image,
                    course.find((c) => c._id === currentCourseId)?.courseName ||
                      "c",
                    o.text || "outcome"
                  ),
                }
              : o
          )
        );
      }
      if (
        currentEditingSection.type === "workExCertificates" &&
        sectionData.certs
      ) {
        sectionData.certs = await Promise.all(
          sectionData.certs.map(async (c) =>
            c.image && c.image instanceof File
              ? {
                  ...c,
                  image: await uploadImageAndGetUrl(
                    c.image,
                    course.find((co) => co._id === currentCourseId)
                      ?.courseName || "c",
                    c.buttonName || "cert"
                  ),
                }
              : c
          )
        );
      }

      await axios.patch(
        `${UPDATE_LANDING_SECTION_API}/${currentCourseId}/${currentEditingSection.type}`,
        { data: sectionData }
      );
      setIsUpdateModalOpen(false);
      setCurrentEditingSection(null);
      setSectionData({});
      await refreshSections(currentCourseId);
      setResp("Section updated successfully!");
      setOpenPopUp(true);
    } catch (err) {
      setErrorSection(err.response?.data?.message || "Error updating section");
    } finally {
      setLoadingSection(false);
    }
  };

  const handleDeleteSection = async () => {
    if (!sectionToDelete) return;
    try {
      await axios.delete(
        `${DELETE_LANDING_SECTION_API}/${sectionToDelete.courseId}/${sectionToDelete.type}`
      );
      setIsDeleteConfirmOpen(false);
      await refreshSections(sectionToDelete.courseId);
      setSectionToDelete(null);
      setResp("Section deleted successfully!");
      setOpenPopUp(true);
    } catch (err) {
      console.error("Error deleting section:", err);
      setResp("Failed to delete section.");
      setOpenPopUp(true);
      setIsDeleteConfirmOpen(false);
    }
  };

  const getAddedSectionTypes = (courseId) =>
    (fetchedSections[courseId] || []).map((s) => s.type);

  return (
    <>
      {course.length > 0 &&
        course.map((c, index) => (
          <div key={c._id}>
            <ListItem>
              <img
                src={c.coursePreview}
                style={{ width: "10%", marginRight: "5%" }}
                alt="Course Thumbnail"
              />
              <ListItemText>
                {c.courseName} {` ₹${c.price}`}{" "}
                {c.priority && `Priority: ${c.priority}`}
              </ListItemText>
              <IconButton
                onClick={() =>
                  setSelectedIndex((p) => (p === index ? null : index))
                }
              >
                <KeyboardDoubleArrowDownIcon />
              </IconButton>
              <ProjectUpload courseId={c._id} setAdded={setAdded} />
              <Button
                onClick={() => {
                  setOpen(true);
                  setCourseId(c._id);
                  axios
                    .get(GET_COURSE + c._id)
                    .then((res) => setPriority(res.data.data[0].priority));
                }}
              >
                Set Priority
              </Button>
              <a
                href={`https://campus.markoknow.com/program/videoplayer/${c._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button>
                  <PreviewIcon />
                </Button>
              </a>
              <SideDrawer
                btn="edit"
                cN={c.courseName}
                courseId={c._id}
                cP={c.coursePreview}
                handleUpdate={checkUpdated}
                handleAdd={checkAdded}
                p={c.price}
                l={c?.learn}
                m={c?.material}
                f={c?.forWhom}
                ts={c?.tags}
                t={c?.trainingEnabled}
                tp={c?.trainingPrice}
              />
              <Button
                onClick={() => {
                  setDeleteCourseIndex(c._id);
                  setOpenDelete(true);
                }}
              >
                Delete
              </Button>
              {!c.isLive ? (
                <Button onClick={() => handleGoLive(c._id)}>
                  <StreamIcon />
                </Button>
              ) : (
                <Button onClick={() => handleCancelGoLive(c._id)}>
                  <CancelIcon />
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                style={{ marginLeft: 8 }}
                onClick={async () => {
                  if (!fetchedSections[c._id]) await refreshSections(c._id);
                  if (
                    getAddedSectionTypes(c._id).length === sectionTypes.length
                  ) {
                    setResp("All section types already added.");
                    setOpenPopUp(true);
                    return;
                  }
                  setAddSectionOpen(true);
                  setCurrentCourseId(c._id);
                  setSelectedSection("");
                  setSectionData({});
                  setErrorSection("");
                }}
              >
                Add Section
              </Button>
              <Button
                onClick={() => handleExpandSections(c._id)}
                style={{ marginLeft: 8 }}
                variant="outlined"
                color="secondary"
              >
                {expandedSections[c._id] ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
                {expandedSections[c._id] ? "Hide" : "See"} Sections
              </Button>
            </ListItem>

            <Collapse in={selectedIndex === index}>
              <List>
                {modules &&
                  modules.map((m, i) => (
                    <ListItem
                      key={i}
                      button
                      onClick={() => {
                        setModuleName(m.title);
                        handleModuleClick(m._id);
                        setSelectedProject(null);
                      }}
                    >
                      {m.title}
                    </ListItem>
                  ))}
              </List>
              <List>
                {projects &&
                  projects.map((p, i) => (
                    <ListItem
                      key={i}
                      button
                      onClick={() => {
                        setProjectName(p.heading);
                        setSelectedProject(p._id);
                        setProjectDescription(p.description);
                      }}
                    >
                      {p.heading}
                    </ListItem>
                  ))}
              </List>
            </Collapse>

            <Collapse in={expandedSections[c._id]}>
              <MuiBox
                mt={1}
                mb={2}
                p={2}
                mx={2}
                style={{ background: "#f5f5f5", borderRadius: 6 }}
              >
                {loadingSections[c._id] ? (
                  <MuiTypography>Loading...</MuiTypography>
                ) : (
                  <>
                    <MuiTypography
                      variant="subtitle1"
                      fontWeight="bold"
                      gutterBottom
                    >
                      Added Landing Sections:
                    </MuiTypography>
                    {(fetchedSections[c._id] || []).length > 0 ? (
                      (fetchedSections[c._id] || []).map((section, idx) => (
                        <MuiBox
                          key={section.type || idx}
                          mb={1}
                          p={1.5}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: 4,
                            background: "#fff",
                          }}
                        >
                          <MuiBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <MuiTypography variant="body1" fontWeight="bold">
                              {
                                sectionTypes.find(
                                  (t) => t.value === section.type
                                )?.label
                              }
                            </MuiTypography>
                            <MuiBox>
                              <Tooltip title="Edit Section">
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    handleEditClick(section, c._id)
                                  }
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Section">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    setSectionToDelete({
                                      type: section.type,
                                      courseId: c._id,
                                    });
                                    setIsDeleteConfirmOpen(true);
                                  }}
                                >
                                  <DeleteIcon fontSize="small" color="error" />
                                </IconButton>
                              </Tooltip>
                            </MuiBox>
                          </MuiBox>
                          <pre
                            style={{
                              fontSize: 12,
                              margin: 0,
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-all",
                            }}
                          >
                            {JSON.stringify(section.data, null, 2)}
                          </pre>
                        </MuiBox>
                      ))
                    ) : (
                      <MuiTypography>
                        No landing sections added yet.
                      </MuiTypography>
                    )}
                  </>
                )}
              </MuiBox>
            </Collapse>
            <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
              {deleteBox}
            </Modal>
          </div>
        ))}

      {/* ADD MODAL */}
      <ModalCustom
        open={addSectionOpen}
        onClose={() => setAddSectionOpen(false)}
        title="Add Landing Page Section"
        actions={
          <>
            <Button onClick={() => setAddSectionOpen(false)}>Close</Button>
            <Button
              onClick={handleSectionSubmit}
              color="primary"
              variant="contained"
              disabled={loadingSection || !selectedSection}
            >
              {loadingSection ? "Submitting..." : "Submit"}
            </Button>
          </>
        }
      >
        {errorSection && (
          <MuiTypography color="error" gutterBottom>
            {errorSection}
          </MuiTypography>
        )}
        <MuiBox mb={2}>
          <Select
            value={selectedSection}
            onChange={(e) => {
              setSelectedSection(e.target.value);
              setSectionData({});
            }}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Select Section Type
            </MenuItem>
            {sectionTypes.map((t) => (
              <MenuItem
                key={t.value}
                value={t.value}
                disabled={getAddedSectionTypes(currentCourseId).includes(
                  t.value
                )}
              >
                {t.label}
              </MenuItem>
            ))}
          </Select>
        </MuiBox>
        {selectedSection === "programmeSnapshot" && (
          <ProgrammeSnapshotForm data={sectionData} setData={setSectionData} />
        )}
        {selectedSection === "programmeOutcomes" && (
          <ProgrammeOutcomesForm data={sectionData} setData={setSectionData} />
        )}
        {selectedSection === "workExCertificates" && (
          <WorkExCertificatesForm data={sectionData} setData={setSectionData} />
        )}
        {selectedSection === "pathway" && (
          <PathwayForm data={sectionData} setData={setSectionData} />
        )}
        {selectedSection === "faq" && (
          <FAQForm data={sectionData} setData={setSectionData} />
        )}
      </ModalCustom>

      {/* UPDATE MODAL */}
      {currentEditingSection && (
        <ModalCustom
          open={isUpdateModalOpen}
          onClose={() => setIsUpdateModalOpen(false)}
          title={`Update ${
            sectionTypes.find((t) => t.value === currentEditingSection.type)
              ?.label
          }`}
          actions={
            <>
              <Button onClick={() => setIsUpdateModalOpen(false)}>
                Cancel
              </Button>
              <Button
                onClick={handleUpdateSectionSubmit}
                color="primary"
                variant="contained"
                disabled={loadingSection}
              >
                {loadingSection ? "Updating..." : "Update"}
              </Button>
            </>
          }
        >
          {errorSection && (
            <MuiTypography color="error" gutterBottom>
              {errorSection}
            </MuiTypography>
          )}
          {currentEditingSection.type === "programmeSnapshot" && (
            <ProgrammeSnapshotForm
              data={sectionData}
              setData={setSectionData}
            />
          )}
          {currentEditingSection.type === "programmeOutcomes" && (
            <ProgrammeOutcomesForm
              data={sectionData}
              setData={setSectionData}
            />
          )}
          {currentEditingSection.type === "workExCertificates" && (
            <WorkExCertificatesForm
              data={sectionData}
              setData={setSectionData}
            />
          )}
          {currentEditingSection.type === "pathway" && (
            <PathwayForm data={sectionData} setData={setSectionData} />
          )}
          {currentEditingSection.type === "faq" && (
            <FAQForm data={sectionData} setData={setSectionData} />
          )}
        </ModalCustom>
      )}

      {/* DELETE DIALOG */}
      <Dialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <MuiTypography>
            Are you sure you want to delete this section?
          </MuiTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteConfirmOpen(false)}>Cancel</Button>
          <Button
            onClick={handleDeleteSection}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* OTHER DIALOGS */}
      <Dialog open={Boolean(selectedModule)} onClose={handleCloseDialog}>
        <DialogTitle>{moduleName}</DialogTitle>
        <DialogContent>
          {videos?.length > 0 && (
            <div>
              <h3>Videos:</h3>
              {videos.map((v) => (
                <div key={v.title}>
                  <h4>{v.title}</h4>
                  <p>{v.link}</p>
                </div>
              ))}
            </div>
          )}
          {pdfs?.length > 0 && (
            <div>
              <h3>PDFs:</h3>
              {pdfs.map((p) => (
                <div key={p.title}>
                  <h4>{p.title}</h4>
                  <p>{p.link}</p>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={Boolean(selectedProject)} onClose={handleCloseDialog}>
        <DialogTitle>{projectName}</DialogTitle>
        <DialogContent>
          Description: <br />
          <div dangerouslySetInnerHTML={{ __html: projectDescription }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
          <Button onClick={handleDeleteProject}>Delete</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle>Priority</DialogTitle>
        <DialogContent>
          <TextField
            type="Number"
            label="Priority"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
          <Button onClick={handleSetPriority}>Submit</Button>
        </DialogActions>
      </Dialog>
      <MessagePopup
        open={openPopUp}
        message={resp}
        handleAlertClose={() => setOpenPopUp(false)}
      />
    </>
  );
}

// --- Helper form components are unchanged ---
const sectionTypes = [
  { value: "programmeSnapshot", label: "Programme Snapshot" },
  { value: "programmeOutcomes", label: "Programme Outcomes" },
  { value: "workExCertificates", label: "Work Ex Certificates" },
  { value: "pathway", label: "Pathway" },
  { value: "faq", label: "FAQ" },
];
function ProgrammeSnapshotForm({ data, setData }) {
  return (
    <div>
      <InputBase
        placeholder="Heading"
        style={{
          margin: "4px 0",
          width: "100%",
          border: "1px solid #ccc",
          padding: "2px 8px",
          borderRadius: 4,
        }}
        value={data.heading || ""}
        onChange={(e) => setData({ ...data, heading: e.target.value })}
      />
      <InputBase
        placeholder="SubHeading"
        style={{
          margin: "4px 0",
          width: "100%",
          border: "1px solid #ccc",
          padding: "2px 8px",
          borderRadius: 4,
        }}
        value={data.subHeading || ""}
        onChange={(e) => setData({ ...data, subHeading: e.target.value })}
      />
      <TextareaAutosize
        minRows={2}
        placeholder="You Get Points (comma separated)"
        style={{
          margin: "4px 0",
          width: "calc(100% - 18px)",
          border: "1px solid #ccc",
          padding: "2px 8px",
          borderRadius: 4,
        }}
        value={data.points || ""}
        onChange={(e) => setData({ ...data, points: e.target.value })}
      />
    </div>
  );
}
function ProgrammeOutcomesForm({ data, setData }) {
  const hC = (i, f, v) => {
    const n = [...(data.outcomes || [])];
    n[i] = { ...n[i], [f]: v };
    setData({ ...data, outcomes: n });
  };
  const hFC = (i, f) => {
    const n = [...(data.outcomes || [])];
    n[i] = { ...n[i], image: f };
    setData({ ...data, outcomes: n });
  };
  return (
    <div>
      <InputBase
        placeholder="Heading"
        style={{
          margin: "4px 0",
          width: "100%",
          border: "1px solid #ccc",
          padding: "2px 8px",
          borderRadius: 4,
        }}
        value={data.heading || ""}
        onChange={(e) => setData({ ...data, heading: e.target.value })}
      />
      {(data.outcomes || []).map((o, i) => (
        <MuiBox key={i} p={1} my={1} border="1px solid #eee" borderRadius={1}>
          <MuiTypography variant="caption">Outcome {i + 1}</MuiTypography>
          <MuiBox display="flex" alignItems="center" gap={1}>
            <Button variant="outlined" component="label" size="small">
              Upload Img
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => hFC(i, e.target.files[0])}
              />
            </Button>
            <Typography variant="caption">
              {o.image &&
                (typeof o.image === "string"
                  ? "Image URL Exists"
                  : o.image.name)}
            </Typography>
            <InputBase
              placeholder="Text Point"
              style={{
                margin: 4,
                flex: 2,
                border: "1px solid #ccc",
                padding: "2px 8px",
                borderRadius: 4,
              }}
              value={o.text || ""}
              onChange={(e) => hC(i, "text", e.target.value)}
            />
          </MuiBox>
        </MuiBox>
      ))}
      <Button
        onClick={() =>
          setData({
            ...data,
            outcomes: [...(data.outcomes || []), { image: null, text: "" }],
          })
        }
      >
        Add Outcome
      </Button>
    </div>
  );
}
function WorkExCertificatesForm({ data, setData }) {
  const hC = (i, f, v) => {
    const n = [...(data.certs || [])];
    n[i] = { ...n[i], [f]: v };
    setData({ ...data, certs: n });
  };
  const hFC = (i, f) => {
    const n = [...(data.certs || [])];
    n[i] = { ...n[i], image: f };
    setData({ ...data, certs: n });
  };
  return (
    <div>
      {(data.certs || []).map((c, i) => (
        <MuiBox key={i} p={1} my={1} border="1px solid #eee" borderRadius={1}>
          <MuiTypography variant="caption">Certificate {i + 1}</MuiTypography>
          <MuiBox display="flex" alignItems="center" gap={1}>
            <InputBase
              placeholder="Button Name"
              style={{
                margin: 4,
                flex: 1,
                border: "1px solid #ccc",
                padding: "2px 8px",
                borderRadius: 4,
              }}
              value={c.buttonName || ""}
              onChange={(e) => hC(i, "buttonName", e.target.value)}
            />
            <Button variant="outlined" component="label" size="small">
              Upload Img
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => hFC(i, e.target.files[0])}
              />
            </Button>
            <Typography variant="caption">
              {c.image &&
                (typeof c.image === "string"
                  ? "Image URL Exists"
                  : c.image.name)}
            </Typography>
          </MuiBox>
        </MuiBox>
      ))}
      <Button
        onClick={() =>
          setData({
            ...data,
            certs: [...(data.certs || []), { buttonName: "", image: null }],
          })
        }
      >
        Add Certificate
      </Button>
    </div>
  );
}
function PathwayForm({ data, setData }) {
  const hC = (i, f, v) => {
    const n = [...(data.weeks || [{}, {}, {}, {}])];
    n[i] = { ...n[i], [f]: v };
    setData({ ...data, weeks: n });
  };
  return (
    <div>
      {[0, 1, 2, 3].map((idx) => (
        <MuiBox key={idx} p={1} my={1} border="1px solid #eee" borderRadius={1}>
          <MuiTypography>Week {idx + 1}</MuiTypography>
          <InputBase
            placeholder="Heading"
            style={{
              margin: "4px 0",
              width: "calc(100% - 18px)",
              border: "1px solid #ccc",
              padding: "2px 8px",
              borderRadius: 4,
            }}
            value={data.weeks?.[idx]?.heading || ""}
            onChange={(e) => hC(idx, "heading", e.target.value)}
          />
          <InputBase
            placeholder="SubHeading"
            style={{
              margin: "4px 0",
              width: "calc(100% - 18px)",
              border: "1px solid #ccc",
              padding: "2px 8px",
              borderRadius: 4,
            }}
            value={data.weeks?.[idx]?.subHeading || ""}
            onChange={(e) => hC(idx, "subHeading", e.target.value)}
          />
        </MuiBox>
      ))}
    </div>
  );
}
function FAQForm({ data, setData }) {
  const hC = (i, f, v) => {
    const n = [...(data.faqs || [])];
    n[i] = { ...n[i], [f]: v };
    setData({ ...data, faqs: n });
  };
  return (
    <div>
      {(data.faqs || []).map((f, i) => (
        <MuiBox key={i} p={1} my={1} border="1px solid #eee" borderRadius={1}>
          <MuiTypography variant="caption">FAQ {i + 1}</MuiTypography>
          <InputBase
            placeholder="Question"
            style={{
              margin: "4px 0",
              width: "calc(100% - 18px)",
              border: "1px solid #ccc",
              padding: "2px 8px",
              borderRadius: 4,
            }}
            value={f.question || ""}
            onChange={(e) => hC(i, "question", e.target.value)}
          />
          <TextareaAutosize
            minRows={2}
            placeholder="Answer"
            style={{
              margin: "4px 0",
              width: "calc(100% - 18px)",
              border: "1px solid #ccc",
              padding: "2px 8px",
              borderRadius: 4,
            }}
            value={f.answer || ""}
            onChange={(e) => hC(i, "answer", e.target.value)}
          />
        </MuiBox>
      ))}
      <Button
        onClick={() =>
          setData({
            ...data,
            faqs: [...(data.faqs || []), { question: "", answer: "" }],
          })
        }
      >
        Add FAQ
      </Button>
    </div>
  );
}
